import React from "react";
export const EditorToolbarDivider = () => {
    return React.createElement("div", { className: "editor-toolbar-divider", role: "separator" });
};
